import { COLOR2, COLOR4, FONT_BOLD_16_18, RADIO_COLOR } from '../../constants';

export const ReturnToSavedApplicationStyles = {
  mainContainer: {
    position: 'relative',
    marginBottom: '6px',
    marginTop: '30px',
    '@media (max-width:600px)': {
      marginBottom: '20px',
    },
  },

  imageGrid: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
  },

  formContainer: {
    width: '454px',
    borderRadius: '10px',
    background: '#FFFFFF',
    padding: '30px',
    margin: '0 auto 65px auto',
    '@media (max-width:600px)': {
      width: '100%',
      margin: '0 0 30px 0',
      borderRadius: 0,
      padding: '20px 20px 0 20px',
    },
  },

  snackbarRoot: {
    width: '100%',
    height: '56px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    '@media (max-width:1310px)': {
      height: 'auto',
    },
    '@media (max-width:600px)': {
      left: 'unset',
      right: 'unset',
    },
  },

  snackbarPosition: {
    position: 'absolute !important',
    top: '25px',
    zIndex: 1,
  },

  snackbarPositionMobile: {
    position: 'absolute !important',
    top: '25px',
    zIndex: 1,
    '@media (max-width:600px)': {
      top: 0,
    },
  },
  snackbarReturnRootBundle: {
    width: '100%',
    height: '56px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    left: 0,
  },
  snackbarReturnRoot: {
    width: '100%',
    height: '56px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
  },

  snackBarBtn: {
    padding: '0px',
    color: '#4F4F4F',
  },

  snackbarRetunStyleViaContentProps: {
    backgroundColor: '#FCF1E8',
    border: '2px solid #F5821F',
    color: '#141414',
    font: 'normal 400 16px/120% Arial',
    maxWidth: '500px',
    position: 'relative',
    left: '10px',
    borderRadius: '6px',
    display: 'flex',
    width: '500px',
    textAlign: 'center',
    alignItems: 'flex-start',
    '@media (max-width:995px)': {
      maxWidth: '75%',
      width: '100%',
      bottom: '10px',
      left: '0px',
      textAlign: 'start',
    },
    '@media (max-width:600px)': {
      left: '-6px',
      maxWidth: '100%',
      bottom: '18px',
    },
  },

  snackbarStyleViaContentProps: {
    color: '#D71721',
    borderRadius: '6px',
    border: '2px solid #D71721',
    backgroundColor: '#FFF2F2',
    width: '100%',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '120%',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    minWidth: 'unset',
  },

  message: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '&.MuiSnackbarContent-message': {
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },

  dd: {
    '&.MuiSnackbarContent-message': {
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },

  gridStyles: {
    marginBottom: '20px',
  },

  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  feeWaivedText: {
    fontStyle: 'Arial',
    marginTop: '30px',
    display: 'flex',
    gap: '13px',
  },

  feeWaivedTextNew: {
    fontStyle: 'Arial',
    marginTop: '20px',
    display: 'flex',
    gap: '13px',
  },

  imageIcon: {
    '@media (min-width:1432px)': {
      marginTop: '15px',
    },
  },

  heading: {
    fontFamily: 'Arial',
    fontSize: '36px',
    fontWeight: 700,
    textAlign: 'center',
    marginTop: '50px',
    marginBottom: '5px',
    color: '#000000',
  },

  sub_heading: {
    fontFamily: 'Arial',
    fontSize: '16px',
    fontWeight: 400,
    marginBottom: '30px',
    textAlign: 'center',
    color: '#000000',
  },

  infoText: {
    color: '#000000',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },

  button_grid: {
    flexWrap: 'nowrap',
    padding: '30px 0 20px 0',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'right',
    '@media (max-width: 1038px)': {
      flexWrap: 'wrap',
    },
    '@media (max-width: 600px)': {
      paddingTop: '30px',
      paddingBottom: '20px',
      justifyContent: 'center',
    },
  },

  personal_button_container: {
    marginTop: '10px',
    justifyContent: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  bundleMainContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'start',
    background: '#FFFFFF',
    minHeight: 'calc(100vh - 62px - 66px)',
    '@media(max-width:600px)': {
      minHeight: 'calc(100vh - 44px - 66px)',
    },
  },

  bundleSubContainer: {
    margin: '48px 0px',
    gap: '24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    width: '100%',
    maxWidth: '630px',
    '@media(max-width:700px)': {
      maxWidth: '500px',
    },
    '@media(max-width:600px)': {
      margin: '24px 12px',
      gap: '18px',
      maxWidth: '375px',
    },
    '@media(max-width:425px)': {
      maxWidth: '320px',
    },
  },

  headingBundle: {
    fontFamily: 'TTNORMSPROBOLD',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    textAlign: 'start',
    // color: '#000000',
    '@media(max-width:600px)': {
      fontSize: '22px',
    },
  },

  subHeadingBundle: {
    fontFamily: 'TTNORMSPROBOLD',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    textAlign: 'start',
    // color: '#000000',
  },

  bundleContentContainer: {
    gap: '24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    '@media(max-width:600px)': {
      gap: '18px',
    },
  },

  bundleTextContainer1: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'start',
    gap: '13px',
  },

  bundleTextContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'start',
    gap: '12px',
  },

  infoTextBundle: {
    fontFamily: 'Arial',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '100%',
    letterSpacing: '0px',
    textAlign: 'start',
    // color: '#444444',
  },

  continueButton: {
    background: RADIO_COLOR,
    borderRadius: '56px',
    padding: '14px 50px 15px 50px',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'center',
    color: COLOR4,
    opacity: 1,
    textTransform: 'none',
    width: '100%',
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },

  inputContainer: {
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
  },
  snackbarRetunStyleViaContentPropsBundle: {
    backgroundColor: '#F5E9F5',
    border: '2px solid #661C69',
    color: '#141414',
    font: 'normal 400 16px/120% Arial',
    maxWidth: '630px',
    position: 'relative',
    left: '10px',
    borderRadius: '6px',
    display: 'flex',
    width: '630px',
    textAlign: 'center',
    alignItems: 'flex-start',
    padding: '0px 16px',
    '@media (max-width:995px)': {
      maxWidth: '75%',
      width: '100%',
      bottom: '10px',
      left: '0px',
      textAlign: 'start',
    },
    '@media (max-width:600px)': {
      left: '-6px',
      maxWidth: '100%',
      bottom: '18px',
    },
  },
  snackbarMessageBundle: {
    fontFamily: 'Arial',
    fontWeight: 700,
    fontSize: '20px !important',
    lineHeight: '120%',
    color: '#141414',
  },
  snackbarMessagesubtext: {
    fontFamily: 'Arial',
    fontWeight: 400,
    fontSize: '16px',
    color: '#000000',
    lineHeight: '120%',
    marginTop: '4px',
    marginLeft: '32px',
  },
};
